__webpack_require__.p = "/Poke-Dex/";